import React from 'react'
import {connect} from 'react-redux'
import rt from '../reactable.scss'
import {Table, Thead, Th, Tr, Td} from 'components/reactable'

import i18n from 'lib/i18n'
const _ = i18n('office')

@connect(state => {
	const broker = state.office.brokers[state.app.brNr]
	const employees = broker && broker.staff
	return {employees}
})
export default class Employees extends React.Component {
	static propTypes = {
		employees: React.PropTypes.object,
	}
	render() {
		const {employees} = this.props
		if (!employees) {return false}

		return (
			<div className={rt.tableContainer}>
				<Table
					hideFilterInput
					className={`noPadding`}
					itemsPerPage={7}
					sortable={['empFirstName', 'empLastName', 'empEmail', 'empMobileNumber', 'empPhoneNumber']}
					defaultSort={{
						column: 'empLastName',
						direction: 'desc',
					}}
				>
					<Thead>
						<Th column="empFirstName">
							<span>{_('name_employees')}</span>
						</Th>
						<Th column="empLastName">
							<span>{_('surname')}</span>
						</Th>
						<Th column="empEmail">
							<span>{_('email')}</span>
						</Th>
						<Th column="empMobileNumber">
							<span>{_('gsm')}</span>
						</Th>
						<Th column="empPhoneNumber">
							<span>{_('telephone')}</span>
						</Th>
					</Thead>
					{employees.map((item, key) =>
						<Tr className="centered" key={key} data={item}>
							<Td column="empFirstName" data={item.firstName}/>
							<Td column="empLastName" data={item.lastName}/>
							<Td column="empEmail" data={item.email}/>
							<Td column="empMobileNumber" data={item.mobileNumber}/>
							<Td column="empPhoneNumber" data={item.phoneNumber}/>
						</Tr>
					)}
				</Table>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./components/office/employees.jsx